import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { Section } from './Shared';
export const FAQ = () => {
  const faqs = [{
    q: '¿Sirve si recién empiezo como terapeuta en MTC?',
    a: 'Especialmente si recién empezás. El sistema te da la estructura clínica desde el primer paciente. No tenés que improvisar ni esperar años de experiencia para trabajar con protocolos probados.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Al confirmar el pago recibís un correo con el link de descarga inmediata. En menos de 5 minutos tenés todo en tu dispositivo.'
  }, {
    q: '¿Necesito imprimirlo todo?',
    a: 'No. Podés usarlo en tablet o computadora durante la sesión. Está diseñado para funcionar en ambos formatos. Las fichas del paciente sí están pensadas para imprimir.'
  }, {
    q: '¿Qué lo diferencia de protocolos que puedo buscar gratis en internet?',
    a: 'Los protocolos gratuitos son genéricos y fragmentados. Este kit tiene algoritmos de 3 pasos listos para aplicar, versión de digitopuntura, checklist de errores frecuentes y recursos adaptados al contexto argentino. Es la diferencia entre una receta suelta y un sistema completo.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días, sin preguntas, devolución del 100%. Escribís a soportelumenakasha@gmail.com y listo.'
  }, {
    q: '¿Puedo compartirlo con otros terapeutas?',
    a: 'No. La licencia es personal e intransferible. Cada terapeuta debe adquirir su propio kit. La redistribución no autorizada viola los derechos de autor.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="max-w-3xl" data-id="element-76">
      <div className="text-center mb-12" data-id="element-77">
        <h2 className="md:text-4xl font-display font-bold mb-4 flex items-center justify-center text-[22px] text-brand-greenDark" data-id="element-78">
          <span className="mr-3" data-id="element-79">❓</span> LO QUE MÁS NOS PREGUNTAN
        </h2>
      </div>

      <div className="space-y-4" data-id="element-80">
        {faqs.map((faq, i) => <div key={i} className="glass-panel rounded-2xl overflow-hidden border-brand-celeste/25 bg-white/80" data-id="element-81">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none hover:bg-brand-surfaceLight/60 transition-colors" data-id="element-82">
              <span className="font-medium pr-8 text-brand-greenDark text-[14px]" data-id="element-83">
                {faq.q}
              </span>
              <ChevronDown className={`w-5 h-5 text-brand-celesteDark transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-84" />
            </button>
            <AnimatePresence data-id="element-85">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-86">
                  <div className="px-6 pb-5 text-brand-text/80 border-t border-brand-celeste/20 pt-4 bg-white/60 text-[13px] leading-relaxed" data-id="element-87">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
};